"use strict";
var ApiEmailQuote = (function () {
    function ApiEmailQuote() {
    }
    return ApiEmailQuote;
}());
exports.ApiEmailQuote = ApiEmailQuote;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-email-quote.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-email-quote.model.js